'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeItem = exports.setItem = exports.getAll = exports.getItem = undefined;

var _koo = require('koo');

var cookies = _interopRequireWildcard(_koo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getItem = exports.getItem = function getItem(key) {
  var item = null;
  try {
    item = JSON.parse(cookies.get(key));
  } catch (error) {}
  return item;
};

var getAll = exports.getAll = function getAll() {
  var items = null;
  try {
    items = cookies.get();
  } catch (error) {}
  return items;
};

var setItem = exports.setItem = function setItem(key, value, options) {
  try {
    cookies.set(key, JSON.stringify(value), options);
  } catch (error) {}
};

var removeItem = exports.removeItem = function removeItem(key, options) {
  try {
    cookies.remove(key, options);
  } catch (error) {}
};